import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsMobileFilterHeader.module.scss";
import {useSongsMobileFilterHeaderLogic} from "./SongsMobileFilterHeader.logic";
import BackButton from "../../../../../../components/common/BackButton";

export const SongsMobileFilterHeader: VoidFunctionComponent = () => {
  const {returnLabel} = useSongsMobileFilterHeaderLogic();
  return (
    <header className={s.container}>
      <BackButton label={returnLabel} useClassName={s.backButton} />
      <h1 className={s.title}>Filter</h1>
    </header>
  );
}
